const React = require('react');
const PropTypes = require('prop-types');
const Loader = require('./loader.react');
const SpringsMixin = require('../mixins/springs');
const classnames = require('classnames');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const createReactClass = require('create-react-class');

const Button = createReactClass({
  propTypes: {
    href: PropTypes.string,
    target: PropTypes.string,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    modifiers: PropTypes.arrayOf(
      PropTypes.oneOf([
        'primary', 'inverse', 'secondary', 'confirm',
        'reject', 'small', 'inline', 'primaryFilled',
      ]),
    ),
    onClick: PropTypes.func,
    children: PropTypes.node.isRequired,
    tagName: PropTypes.oneOf(['button', 'a', 'label']),
    className: PropTypes.string,
    id: PropTypes.string,
    loadingAnimation: PropTypes.bool,
    error: PropTypes.bool,
    style: PropTypes.object,
  },

  mixins: [
    PureRenderMixin,
    SpringsMixin([
      {
        key: 'self',
        tension: 200,
        friction: 15,
        initialValue: 1,
      },
    ]),
  ],

  getDefaultProps() {
    return {
      modifiers: [],
      tagName: 'a',
      style: {},
    };
  },

  getInitialState() {
    return {
      isHovered: false,
      loaderAnimating: false,
    };
  },

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.loadingAnimation &&
      !nextProps.loading &&
      this.props.loading
    ) {
      this.setState({ loaderAnimating: true });
    }
  },

  onClick(e) {
    if (this._disabled()) {
      e.preventDefault();
    } else if (this.props.onClick) {
      this.props.onClick(e);
    }
  },

  onMouseOver() {
    this.setState({
      isHovered: true,
    });
  },

  onMouseOut() {
    this.setState({
      isHovered: false,
    });
  },

  _disabled() {
    return this.props.disabled || this.props.loading;
  },

  _onFinishAnimating() {
    this.setState({
      loaderAnimating: false,
    });
  },

  render() {
    const { tagName, className, disabled, modifiers } = this.props;

    const classes = classnames(className, 'Button', {
      'is-disabled': disabled,
    }, modifiers.map(m => `Button--${ m }`));

    let children = this.props.children;
    if (this.props.loading || this.state.loaderAnimating) {
      const { isHovered, loaderAnimating } = this.state;
      const inversed = modifiers.includes('inverse') || modifiers.includes('primaryFilled');
      const invertLoader = (inversed && !isHovered) || (!inversed && isHovered);

      children = (
        <Loader
          animating={ loaderAnimating }
          inverse={ invertLoader }
          onFinishAnimating={ this._onFinishAnimating }
          error={ this.props.error }
        />
      );
    }

    const style = {
      ...this.props.style,
      transform: `scale(${ this.state.selfSpringValue })`,
      WebkitTransform: `scale(${ this.state.selfSpringValue })`,
    };

    const spring = this.springRefs.self;
    const springStart = () => {
      if (!this._disabled()) {
        spring.setEndValue(0.95);
      }
    };

    const springEnd = () => {
      spring.setEndValue(1);
    };

    return React.createElement(tagName, {
      onMouseOver: this.onMouseOver,
      onMouseOut: this.onMouseOut,
      onMouseDown: springStart,
      onMouseLeave: springEnd,
      onMouseUp: springEnd,
      href: this.props.href,
      target: this.props.target,
      className: classes,
      id: this.props.id,
      onClick: this.onClick,
      style,
    }, children);
  },
});

module.exports = Button;
